// Serializes Adsterra-style ("atOptions") ad script loading so multiple ad
// units on the same page never overwrite each other's shared `atOptions`
// global before their invoke.js script has had a chance to read it.
let queue = Promise.resolve();

export const enqueueAdLoad = (loadFn) => {
  queue = queue.then(loadFn).catch(() => {});
  return queue;
};
